<template>
  <div class="mask"></div>
  <router-view/>
</template>

<style lang="scss">
html { min-height: 100% }
body {
  height: 100%;
  background: url(./assets/img/bg.jpg) center / cover;
}
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: -1;
  background: rgba(0, 0, 0, .7)
}
</style>
